import { PropertySpyItemDetailChangeListTable } from '../../presentationals/PropertySpyItemDetailChangeListTable'

interface PropertySpyItemDetailChangeListViewContainerProps {
    data: any[]
}

export const PropertySpyItemDetailChangeListViewContainer = (props: PropertySpyItemDetailChangeListViewContainerProps): JSX.Element => {
    const {
        data = []
    } = props


    return (
        <PropertySpyItemDetailChangeListTable
            data={data}
        />
    )
}